export default function StatusSection({ formData, errors, refs, handleInputChange }) {
  return (
    <div className="mb-6">
      <label className="block mb-2 font-semibold">Status</label>

      <select
        ref={refs.status}
        name="status"
        value={formData.status}
        onChange={handleInputChange}
        className="border p-3 w-full"
      >
        <option value="draft">Draft</option>
        <option value="published">Publish</option>
        <option value="scheduled">Schedule</option>
      </select>

      {formData.status === "scheduled" && (
        <input
          ref={refs.ScheduledDate}
          type="datetime-local"
          name="ScheduledDate"
          value={formData.ScheduledDate}
          onChange={handleInputChange}
          className="border p-3 w-full mt-2"
        />
      )}
    </div>
  );
}
